var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"components-my-editor"},[_c('div',{ref:"myEditorNav",staticClass:"myEditorNav",attrs:{"name":"n_my_editor_nav"}}),_c('div',{ref:"myEditor",staticClass:"myEditorConten"})])
}
var staticRenderFns = []

export { render, staticRenderFns }